<template>
  <!-- partial:../../partials/_navbar.html -->
  <nav class="navbar">
    <a href="#" class="sidebar-toggler">
      <i data-feather="menu"></i>
    </a>
    <div class="navbar-content">
      <form class="search-form">
        <div class="input-group">
          <div class="input-group-text">
            <i data-feather="search"></i>
          </div>
          <input
            type="text"
            class="form-control"
            id="navbarForm"
            placeholder="Search here..."
          />
        </div>
      </form>
      <ul class="navbar-nav">
        <li class="nav-item">
          <a href="javascript:void" @click="logout" class="text-body ms-0">
              <i class="me-2 icon-md" data-feather="log-out"></i>
            </a>
        </li>
      </ul>
    </div>
  </nav>
  <!-- partial -->
</template>

<script type="text/javascript">
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions({
      logOut: "auth/logOut",
    }),
    logout() {
      this.logOut();
      location.replace("/");
    },
  },
};
</script>